// src/components/orderentry/components/MoneyCell.jsx
export default function MoneyCell({ value }) {
  if (value == null || value === '') {
    return '—';
  }

  const n = Number(value);
  if (Number.isNaN(n)) {
    return String(value);
  }

  return n.toLocaleString(undefined, { style: 'currency', currency: 'USD' });
}
